<template>
  <!--票务系统-->
  <article>
    <div class="caption">
      <h2>大数据监控</h2>
      <span>BIG DATA MONITORING</span>
    </div>

    <div class="content">
      大数据能够通过改进景区机构和辅助景区的决策，使景区更加英明地提高景区工作效率，为利益相关者服务。<br />
      利用各种渠道的各种数据，快速获得关键、准确的深刻见解，将显著改进景区的各项关键政策和工作效率
    </div>

    <div class="body">
      <div class="item">
        <div class="head">
          <img src="@/assets/images/product/bigdata/1.png" alt="" srcset="">
          <div class="title">实时监控</div>
        </div>
        <p>实时对各个出入口、重点区域的客流数据监控，实现数据监测与数据推送功能，数据数字化、图形化显示</p>
      </div>
      <div class="item">
        <div class="head">
          <img src="@/assets/images/product/bigdata/2.png" alt="" srcset="">
          <div class="title">客流峰值预警</div>
        </div>
        <p>监测点位、监测区域达到设定的最大瞬时承载量时，系统自动发出预警，提示管理人员前往处理，及时采取疏导及应急措施</p>
      </div>
      <div class="item">
        <div class="head">
          <img src="@/assets/images/product/bigdata/3.png" alt="" srcset="">
          <div class="title">数据查询与统计分析</div>
        </div>
        <p>实现各个点位、各个区域的客流数据的统计、对比分析，生成各种数据报表，积累长时间数据，为科学决策提供数据支持</p>
      </div>
      <div class="item">
        <div class="head">
          <img src="@/assets/images/product/bigdata/4.png" alt="" srcset="">
          <div class="title">数据显示和发布</div>
        </div>
        <p>系统提供数据开放接口，支持数据融合，可通过户外显示屏实现数据的显示</p>
      </div>
    </div>
  </article>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
article {
  display: flex;
  flex-direction: column;

  > .caption {
    display: flex;
    flex-direction: column;
    align-items: center;
    > h2 {
      display: inline-block;
      border-bottom: 2px solid #666666;
      padding-bottom: 5px;
      font-size: 24px;
    }

    span {
      font-size: 14px;
      font-weight: lighter;
    }
  }

  > .content {
    margin: 20px 0;
    text-align: center;
    font-size: 14px;
  }

  > .body {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 20px;
    margin-bottom: -0.15rem;

    > .item {
      width: 49%;
      text-align: center;

      > .head {
        position: relative;
        margin-bottom: 0.25rem;

        > img {
          width: 70%;
        }

        > .title {
          width: 60%;
          height: 60px;
          line-height: 60px;
          position: absolute;
          left: 18%;
          bottom: -30px;
          font-size: 20px;
          font-weight: bold;
          text-align: left;
          padding-left: 0.05rem;
          background-color: white;
          border-left: 5px solid #145a84;
          box-shadow: 0px 2px 15px 0px rgba(80, 80, 80, 0.3);
        }
      }

      > p {
        padding: 0 0.388rem;
        text-align: justify;
        font-size: 14px;
        margin-bottom: 0.2rem;
      }
    }
  }
}
</style>